<template>
  <div class="login">
    <div class="login-content">
      <div class="login-form">
        <div class="title">蓝小房管理系统</div>
        <el-form class="form-content" ref="form" :model="form" :rules="formRules" label-width="0">
          <el-form-item prop="user_name">
            <el-input v-model="form.account" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
        </el-form>
        <el-button
          class="login-btn"
          :loading="btnLoading"
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/api/api";
export default {
  data() {
    return {
      btnLoading: false,
      formRules: {
        account: [{ required: true, message: "请输入", trigger: "change" }],
        password: [{ required: true, message: "请输入", trigger: "change" }]
      },
      form: {
        account: "",
        password: ""
      }
    };
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          Api.login(this.form).then(res => {
            this.btnLoading = false;
            if (
              res.user_info &&
              res.user_info.role === "agency" &&
              res.user_info.target_buildings.length == 0
            ) {
              this.$message({
                message: "该账号没有登录权限",
                type: "error"
              });
              return;
            }
            // if (
            //   res.user_info &&
            //   res.user_info.role !== "admin" &&
            //   res.user_info.role !== "admin-viewer"
            // ) {
            //   this.$message({
            //     message: "该账号没有登录权限",
            //     type: "error"
            //   });
            //   return;
            // }
            this.$store.commit("setUserInfo", res.user_info.name || "管理员");
            localStorage.setItem("token", res.token);
            localStorage.setItem("userInfo", JSON.stringify(res.user_info));
            window.location.reload();
          }).catch(() => {
            this.btnLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(124deg, #def7fc 1%, #f9eaeb 87%);
  display: flex;
  align-items: center;
  justify-content: center;
  .login-content {
    width: 450px;
    height: 400px;
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    .login-form {
      width: 450px;
      padding: 0 75px;
      margin-top: 50px;
      .title {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #2e2d27;
        line-height: 28px;
        text-align: center;
      }
      .login-btn {
        width: 100%;
      }
    }
  }
  .form-content {
    margin-top: 40px;
    margin-bottom: 80px;
  }
}
::v-deep .el-form-item__content {
  .el-input__inner {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #dcdfe6;
  }
  input {
    border: none;
  }
}
</style>